(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('BankAccountInfoDeleteController', BankAccountInfoDeleteController);

    BankAccountInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'BankAccountInfo'];

    function BankAccountInfoDeleteController($uibModalInstance, entity, BankAccountInfo) {
        var vm = this;

        vm.bankAccountInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            BankAccountInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
